import { normalizeFunnelAddress } from '@/stores/propertyValuation/services';
import { Address, Location } from '@/stores/types/propertyValuation';

export interface FunnelAbandonmentPropertyAddress {
  street?: string;
  postalCode?: string;
  city?: string;
}

const normalizeAddressSegment = (value: string | undefined): string =>
  (value ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');

export function hasUsableFunnelAddress(location: Location): boolean {
  const address = normalizeFunnelAddress(location);
  const hasStreetNumber = Boolean(address.street && /\d/.test(address.street));

  return Boolean(
    address.postalCode &&
    address.city &&
    address.street &&
    hasStreetNumber &&
    address.lat &&
    address.lon,
  );
}

export function formatFunnelAbandonmentAddress(location: Location): string {
  const address = normalizeFunnelAddress(location);
  const cityLine = [address.postalCode, address.city].filter(Boolean).join(' ');

  return [address.street, cityLine].filter(Boolean).join(', ');
}

export function matchesFunnelAbandonmentAddress(
  funnelAddress: Address,
  propertyAddress: FunnelAbandonmentPropertyAddress,
): boolean {
  return (
    normalizeAddressSegment(funnelAddress.street) ===
      normalizeAddressSegment(propertyAddress.street) &&
    normalizeAddressSegment(funnelAddress.postalCode) ===
      normalizeAddressSegment(propertyAddress.postalCode) &&
    normalizeAddressSegment(funnelAddress.city) === normalizeAddressSegment(propertyAddress.city)
  );
}
